/**
 * @vuepress
 * ---
 * title: Providers Units
 * ---
 */

import Transformer from '../transformer'

/**
 * @class MinialProviderTransformer
 * @author José Luis Ruiz
 */
class MinialProviderTransformer extends Transformer {
  static fetch({
    name,
    commercial_name: commercialName,
    provider_number: providerNumber,
    rfc,
    slug,
    id,
    resico,
    retention_eight_percent: retentionEightPercent,
    retention_four_percent: retentionFourPercent,
    ranking,
    does_bill: doesBill,
    pay_to: payTo
  }) {
    return {
      name,
      commercialName,
      providerNumber,
      rfc,
      slug,
      id,
      resico,
      retentionEightPercent,
      retentionFourPercent,
      ranking,
      payTo,
      doesBill
    }
  }
}
export default MinialProviderTransformer
